<template>
  <div v-if="selectedMenu == 1" class="uv-card">
    <div class="uv-card-body">
      <div class="d-flex align-center justify-space-between mb-2">
        <ModuleHeader>PUNTOS DE VENTA</ModuleHeader>
        <v-btn @click="$router.push('/cajas/cortes')" color="primary" depressed class="text-none">
          <v-icon left small>mdi-monitor-dashboard</v-icon>
          Control General de Cortes
        </v-btn>
      </div>
      <p>
        Los puntos de venta pueden migrarse y crearse desde la computadora donde
        se instalará el sistema. Una caja solo debe existir en una computadora
        a la vez.
      </p>
      <uv-data-table
        :config="config"
        :data="data_cajas"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>

    <!-- <modal v-model="showModalQrCaja" :showFooter="false" title="Cajas">
      <QrCreator :config="qrConfig.config" :descargar="qrConfig.descargar" :key="QrCajaIndex"></QrCreator>
    </modal> -->

    <v-dialog
      v-model="showModalQrCaja"
      :showFooter="false"
      title="Generar QR "
      max-width="350"
      persistent
    >
      <v-card>
        <v-toolbar dark :color="$pgsHelper.uiConfig().mainColor">
          <v-btn icon dark @click="showModalQrCaja = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Generar QR</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <div class="my-2 mx-6 text-center font-weight-bold">
          <QrCreator :config="qrConfig.config" :descargar="qrConfig.descargar" :key="QrCajaIndex" />
        </div>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>



  </div>
</template>

<script>
import uvDataTable from "../MainComponents/DataTable.vue";
import QrCreator from "../MainComponents/QrCreator.vue";

export default {
  name: "InstalacionesCrud",
  components: {
    uvDataTable,
    QrCreator,
  },
  data() {
    return {
      formIndex: 0,
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: true,
        rawText: "Instalaciones",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Ver Cortes",
            icon: "lni lni-graph",
            buttonId: "verCaja",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "Nomb",
          },
          {
            text: "Departamento",
            value: "Dpto",
            canBeFiltered: true,
          },
          {
            text: "Clave",
            value: "Code",
            format: (row) => {
              return this.tent + "@" + row.Code;
            },
          },
          {
            canBeFiltered: true,
            text: "Centros de Consumo",
            value: "Orgs",
            format: (row) => {
              let Origen = "";
              row["Orgs"].forEach((id) => {
                Origen +=
                  "  " +
                  (this.$pgsHelper.getById(this.Origenes, "id", id)
                    ? this.$pgsHelper.getById(this.Origenes, "id", id)
                        .Nombre
                    : "Cargando..."+id);
              });
              return Origen;
            },
          },
          {
            canBeFiltered: true,
            text: "Estatus",
            value: "Activo",
            format: (row) => {
              return row["Activo"] ? "Activo" : "Inactivo";
            },
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "green",
                text: "Generar QR",
                buttonId: "qrGenerate",
                value: "id",
              },
            ],
          },
        ],
      },
      idSelected: "",
      data_cajas: [],
      selectedMenu: 1,

      qrConfig: {
        config: {},
        descargar: {},
      },
      showModalQrCaja: false,
      QrCajaIndex: 0,
    };
  },
  computed: {
    Origenes() {
      return this.$store.getters.getCentrosConsumo;
    },
    tent() {
      return this.$store.getters.getFirebaseApp.tenant;
    },
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "verCaja") {
        this.$router.push({
          path: "/cajas/cajaDetail/" + idSelected[0],
        });
      }

      if (buttonId == "qrGenerate") {
        let caja = this.$pgsHelper.getById(this.data_cajas, "id", idSelected);

        this.QrCajaIndex++;
        this.showModalQrCaja = true;
        this.qrConfig.config = {
          styles: {
            width: 300,
            height: 300,
            colorDark: "#000000",
            colorLight: "#FFFFFF",
          },
          qr: {
            text: this.tent + "@" + caja.Code,
            level: "H",
          },
          text: {
            content: caja.Nomb,
            font: "20px roboto",
            color: "#000000",
            margin: -15,
          },
        };
        this.qrConfig.descargar = {
          nombreArchivo: caja.Nomb,
          extension: "jpeg",
        };
      }
    },

    async getCajas() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/Cajas"
        );
      this.data_cajas = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
  },
  beforeMount: function () {},
  mounted: function () {
    this.getCajas();
  },
};
</script>
